const state = {
  isLoading: true
}

const mutations = {
  SET_LOADING: (state, value) => {
    state.isLoading = value
  }
}

const actions = {
  updateLoading({ commit }, payload) {
    commit('SET_LOADING', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
